<template>
  <div v-if="format == 'header'">
    <span
      v-for="(scope, scope_id) in currentScope"
      :key="scope_id"
      color="grey lighten"
      text-color="white"
    >
      {{ scope.description }}: {{ scope.value }}
      <br>
    </span>
  </div>
  <span v-else-if="format == 'matrix'">
    <span v-for="(scope, scope_id) in currentScope" :key="scope_id">
      <span>{{ scope.value }}</span>
      <span v-if="scope_id < currentScope.length - 1">&nbsp; / &nbsp;</span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    scope: {
      type: [Object, String, Array],
      default: () => []
    },
    mapping: {
      type: Object,
      default: () => {
        return {
          region: "Region",
          division: "Division",
          site: "Site",
          area: "Area",
          process: "Process"
        };
      }
    },
    format: {
      type: String,
      default: "header"
    }
  },
  methods: {},
  computed: {
    currentScope() {
      const scope = this.scope;
      if (scope instanceof String) {
        return [{ id: "scope", description: "Bereich", value: scope }];
      } else if (scope instanceof Array) {
        return [
          { id: "scope", description: "Bereich", value: scope.join(", ") }
        ];
      } else if (scope instanceof Object) {
        let mapping = this.mapping;
        let result = [];

        for (let key in mapping) {
          if (this.scope[key]) {
            result.push({
              id: key,
              description: mapping[key],
              value: this.scope[key]
            });
          }
        }

        return result;
      } else {
        return scope;
      }
    }
  }
};
</script>
